// src/config.js
export const API_BASE_URL = "https://api-salesportal.gibsonusa.com";
export const ADMIN_URL = "https://admin-salesportal.gibsonusa.com/";
